export default __webpack_public_path__ + "static/l5-case2-786c4f75b7e7e2323c7c9b1cd9306e47.jpg";